import Vue from 'vue'
import axios from 'axios'
import VueCookie from 'vue-cookie'
import { initMarketJwtToken, initMarketUser } from '../plugins/localStorage'
import config from '@/helpers/config'

Vue.use(VueCookie)

const state = {
  token: initMarketJwtToken,
  user: initMarketUser
}

const mutations = {
  setToken (state, token) {
    state.token = token
  },
  resetToken (state) {
    state.token = ''
  },
  setUser (state, user) {
    state.user = user
  },
  resetUser (state) {
    state.user = {}
  }
}

const actions = {
  async login ({ commit }, user) {
    const endpoint = config.apiUrl + '/users/login'
    const { data } = await axios.post(endpoint, user)
    commit('setToken', data.payload.token)
    commit('setUser', data.payload.user)
  },
  logout ({ commit }) {
    commit('resetToken')
    commit('resetUser')
    Vue.cookie.delete('ykx-v2-cookie-jwt-token', {domain: (process.env.NODE_ENV === 'production' ? '.dataslicer.io' : 'localhost')})
    Vue.cookie.delete('ykx-v2-cookie-jwt-user', {domain: (process.env.NODE_ENV === 'production' ? '.dataslicer.io' : 'localhost')})
  },
  async activate ({ commit }, user) {
    const endpoint = config.apiUrl + '/users/activate'
    await axios.post(endpoint, user)
  }
}

const getters = {
  isLoggedIn (state) {
    if (!state.token) {
      return false
    } else {
      return true
    }
  },
  currentUser (state) {
    if (!state.token) {
      return null
    } else {
      return state.user
    }
  },
  currentToken (state) {
    if (!state.token) {
      return null
    } else {
      return state.token
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js